<template>
  <div
    class="console-sidebar"
    title="Sidebar"
    left
  >
    <ul class="list-unstyled sidebar-content">
      <li>
        <router-link :to="'/console/news'">最新消息</router-link>
      </li>
      <li>
        <router-link :to="'/console/shops'">店家列表</router-link>
      </li>
      <li>
        <router-link :to="'/console/coin'">yumCoin</router-link>
      </li>
      <li>
        <router-link :to="'/console/recommendCode'">推薦碼輸入</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isPanelOpen: false
    }
  },
  methods: {
    openSidebarPanel () {
      this.isPanelOpen = true
    },
    closeSidebarPanel (evt) {
      this.isPanelOpen = false
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/css/_variables.scss";

.console-sidebar {
  background-color: $light-gray;
}
ul.sidebar-content {
  li {
    a {
      padding: 0.2rem 0.4rem;
      color: $basic-black;
      text-decoration: none;
      font-size: 1.1em;
      display: block;
    }
    a:hover {
      color: $basic-white;
      background-color: $gray;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/console/Sidebar.vue